import React from 'react';
import PropTypes from 'prop-types';

class SettingsContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className='settings-container'>
        {this.props.children}
      </div>
    );
  }
};

export default SettingsContainer;



// WEBPACK FOOTER //
// ./src/browser/components/settings/settings-container.js